import { graphql, HttpResponse } from 'msw'
import { type EnrollmentMultiFinancesData, type EnrollmentMultiFinancesSubmitOutput } from '../../../../models'
import { EnrollmentTaxFilingStatusType } from '../../../../models/enrollment/enrollment'
import { MaritalStatus } from '../../../../models/customer/customer'

export const getEnrollmentMultiFinancesDataMock: EnrollmentMultiFinancesData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/finances',
  enrollmentData: {
    applicationId: '305802305',
    progress: 40,
    investmentProfile: {
      taxFilingStatus: EnrollmentTaxFilingStatusType.Single,
      maritalStatus: MaritalStatus.SINGLE,
    },
    personalAnnualGrossIncome: 100000,
    personalNetWorthRange: '100000-200000',
  },
}

export const submitEnrollmentMultiFinancesDataMock: EnrollmentMultiFinancesSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/investment-goals',
}

export const mockGetEnrollmentMultiFinancesData = graphql.mutation('getEnrollmentMultiFinancesData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiFinancesDataMock } })
})

export const mockSubmitEnrollmentMultiFinancesData = graphql.mutation('submitEnrollmentMultiFinancesData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiFinancesDataMock } })
})

export const mockEnrollmentMultiFinances = [mockGetEnrollmentMultiFinancesData, mockSubmitEnrollmentMultiFinancesData]
